import { Accordion, AccordionItem } from '@spark-web/accordion';
import { Box } from '@spark-web/box';
import { Button, ButtonLink } from '@spark-web/button';
import { Divider } from '@spark-web/divider';
import { ContentDialog } from '@spark-web/modal-dialog';
import { Text } from '@spark-web/text';
import { INCOME_VERIFICATION } from '@utils';

interface OpenBankingExplanationModalProps {
  isOpen: boolean;
  onToggle: () => void;
  onConnect: () => void;
  isCdrChallenger?: boolean;
}

export function OpenBankingExplanationModal({
  isOpen,
  onConnect,
  onToggle,
  isCdrChallenger,
}: OpenBankingExplanationModalProps) {
  const {
    CDR_EXPLANATION_TITLE,
    CDR_EXPLANATION_TITLE_CHALLENGER,
    CDR_EXPLANATION_DESCRIPTION,
    CDR_EXPLANATION_DESCRIPTION_CHALLENGER,
    CDR_QUESTION_1,
    CDR_QUESTION_1_CHALLENGER,
    CDR_QUESTION_1_ANSWER,
    CDR_QUESTION_1_ANSWER_CHALLENGER,
    CDR_QUESTION_2,
    CDR_QUESTION_2_CHALLENGER,
    CDR_QUESTION_2_ANSWER,
    CDR_QUESTION_2_ANSWER_CHALLENGER,
    CDR_QUESTION_3,
    CDR_QUESTION_3_CHALLENGER,
    CDR_QUESTION_3_ANSWER,
    CDR_QUESTION_3_ANSWER_CHALLENGER,
    CDR_QUESTION_4,
    CDR_QUESTION_4_ANSWER,
  } = INCOME_VERIFICATION;

  const title = isCdrChallenger ? CDR_EXPLANATION_TITLE_CHALLENGER : CDR_EXPLANATION_TITLE;
  const description = isCdrChallenger ? CDR_EXPLANATION_DESCRIPTION_CHALLENGER : CDR_EXPLANATION_DESCRIPTION;
  const question1 = isCdrChallenger ? CDR_QUESTION_1_CHALLENGER : CDR_QUESTION_1;
  const question1Answer = isCdrChallenger ? CDR_QUESTION_1_ANSWER_CHALLENGER : CDR_QUESTION_1_ANSWER;
  const question2 = isCdrChallenger ? CDR_QUESTION_2_CHALLENGER : CDR_QUESTION_2;
  const question2Answer = isCdrChallenger ? CDR_QUESTION_2_ANSWER_CHALLENGER : CDR_QUESTION_2_ANSWER;
  const question3 = isCdrChallenger ? CDR_QUESTION_3_CHALLENGER : CDR_QUESTION_3;
  const question3Answer = isCdrChallenger ? CDR_QUESTION_3_ANSWER_CHALLENGER : CDR_QUESTION_3_ANSWER;

  return (
    <>
      <ContentDialog title={title} isOpen={isOpen} onToggle={onToggle}>
        <Text>{description}</Text>
        <Accordion type="multiple">
          <AccordionItem value="item-1" label={question1} level="4">
            <Text tone="muted">{question1Answer}</Text>
          </AccordionItem>
          <Divider />
          <AccordionItem value="item-2" label={question2} level="4">
            <Text tone="muted">{question2Answer}</Text>
          </AccordionItem>
          <Divider />
          <AccordionItem value="item-3" label={question3} level="4">
            <Text tone="muted">{question3Answer}</Text>
          </AccordionItem>
          <Divider />
          {isCdrChallenger && (
            <>
              <AccordionItem value="item-4" label={CDR_QUESTION_4} level="4">
                <Text tone="muted">{CDR_QUESTION_4_ANSWER}</Text>
              </AccordionItem>
              <Divider />
            </>
          )}
          <Box display="flex" justifyContent="end" paddingY="small" gap="large">
            <Button prominence="none" tone="neutral" onClick={onToggle} data={{ testid: 'cdr-explanation-close-btn' }}>
              Cancel
            </Button>
            <Button onClick={onConnect}>{isCdrChallenger ? 'Verify now' : 'Use fast-track verification'}</Button>
          </Box>
        </Accordion>
      </ContentDialog>
    </>
  );
}
